// extracted by mini-css-extract-plugin
export var badge = "customer-testimonial-module--badge--20438";
export var card = "customer-testimonial-module--card--02228";
export var cardWrapper = "customer-testimonial-module--cardWrapper--4f666";
export var containerWrapper = "customer-testimonial-module--containerWrapper--97021";
export var cta = "customer-testimonial-module--cta--128e8";
export var ctaArrow = "customer-testimonial-module--ctaArrow--bca91";
export var headingContent = "customer-testimonial-module--headingContent--0e67c";
export var headingText = "customer-testimonial-module--headingText--24608";
export var headline = "customer-testimonial-module--headline--f71d0";
export var name = "customer-testimonial-module--name--d5556";
export var showLessArrow = "customer-testimonial-module--showLessArrow--caef8";
export var testimonialCopy = "customer-testimonial-module--testimonialCopy--d4ab4";
export var wrapper = "customer-testimonial-module--wrapper--63d44";